window.SideCartRecommendations = (function () {
  var LIMIT = 4;
  var DEBOUNCE_MS = 200;

  var debounceTimer = null;
  var lastProductId = null;
  var fallbackHandle = 'new-arrivals';

  // ── Initialise (called from footer.liquid after CartJS.init) ─────────────
  function init() {
    var el = document.getElementById('side-recs');
    if (!el) return;
    fallbackHandle = el.getAttribute('data-fallback-collection') || 'new-arrivals';
    fetchAndRender();
  }

  // ── Called from footer.liquid on cart.requestComplete ────────────────────
  function refresh(cart) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      var items = cart && cart.items ? cart.items : [];
      if (!items.length) return;
      var productId = items[0].product_id;
      if (productId === lastProductId) return;
      fetchAndRender();
    }, DEBOUNCE_MS);
  }

  // ── Core fetch + render ───────────────────────────────────────────────────
  function fetchAndRender() {
    if (typeof CartJS === 'undefined' || !CartJS.cart || !CartJS.cart.items.length) return;

    var items = CartJS.cart.items;
    var productId = items[0].product_id;
    var cartProductIds = items.map(function (i) { return i.product_id; });

    lastProductId = productId;
    showSkeletons();

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + LIMIT + '&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.products || []).filter(function (p) {
          return cartProductIds.indexOf(p.id) === -1;
        });
        if (products.length >= LIMIT) {
          return products.slice(0, LIMIT);
        }
        var needed = LIMIT - products.length;
        var excludeIds = cartProductIds.slice();
        excludeIds.push(productId);
        products.forEach(function (p) { excludeIds.push(p.id); });
        return fetchFallback(needed, excludeIds).then(function (extras) {
          return products.concat(extras).slice(0, LIMIT);
        });
      })
      .then(renderCards)
      .catch(function () {
        var excludeIds = cartProductIds.slice();
        excludeIds.push(productId);
        fetchFallback(LIMIT, excludeIds)
          .then(renderCards)
          .catch(function () { showSkeletons(); });
      });
  }

  function fetchFallback(needed, excludeIds) {
    return fetch('/collections/' + fallbackHandle + '/products.json?limit=12')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        return (data.products || [])
          .filter(function (p) { return excludeIds.indexOf(p.id) === -1; })
          .slice(0, needed);
      });
  }

  // ── Skeleton ──────────────────────────────────────────────────────────────
  function showSkeletons() {
    var track = document.getElementById('side-recs-track');
    if (!track) return;
    var html = '';
    for (var i = 0; i < LIMIT; i++) {
      html += '<div class="side-recs__card side-recs__card--skeleton" aria-hidden="true"></div>';
    }
    track.innerHTML = html;
  }

  // ── Render cards ──────────────────────────────────────────────────────────
  function renderCards(products) {
    var track = document.getElementById('side-recs-track');
    if (!track) return;
    if (!products || !products.length) {
      track.innerHTML = '';
      return;
    }
    track.innerHTML = products.map(buildCard).join('');
    bindEvents(track);
  }

  function buildCard(product) {
    var img = buildImage(product);
    var price = formatMoney(product.price_min);
    var isMultiVariant = product.variants && product.variants.length > 1 &&
      !(product.variants.length === 1 && product.variants[0].title === 'Default Title');

    var addBtn, picker;
    if (isMultiVariant) {
      addBtn = '<button type="button"'
        + ' class="side-recs__card-add side-recs__card-add--expand"'
        + ' data-product-id="' + product.id + '"'
        + ' aria-expanded="false"'
        + ' aria-label="Choose size for ' + esc(product.title) + '"'
        + '>Add</button>';
      picker = buildPicker(product);
    } else {
      var variantId = product.variants[0].id;
      addBtn = '<button type="button"'
        + ' class="side-recs__card-add"'
        + ' data-variant-id="' + variantId + '"'
        + ' aria-label="Add ' + esc(product.title) + ' to cart"'
        + '>Add</button>';
      picker = '';
    }

    return '<div class="side-recs__card">'
      + '<a href="' + product.url + '" class="side-recs__card-link">'
        + '<div class="side-recs__card-image">' + img + '</div>'
        + '<div class="side-recs__card-details">'
          + '<div class="side-recs__card-name">' + esc(product.title) + '</div>'
          + '<div class="side-recs__card-price">' + price + '</div>'
        + '</div>'
      + '</a>'
      + addBtn
      + picker
      + '</div>';
  }

  function buildImage(product) {
    if (!product.featured_image) return '';
    var src = product.featured_image.src || product.featured_image;
    var src1x = sizedUrl(src, 120, 150);
    var src2x = sizedUrl(src, 240, 300);
    return '<img'
      + ' src="' + src1x + '"'
      + ' srcset="' + src1x + ' 1x, ' + src2x + ' 2x"'
      + ' alt="' + esc(product.title) + '"'
      + ' loading="lazy"'
      + ' width="120" height="150"'
      + '>';
  }

  function buildPicker(product) {
    var swatches = product.variants.map(function (v) {
      var label = v.option1 || v.title;
      var unavailable = !v.available;
      return '<button type="button"'
        + ' class="side-recs__swatch' + (unavailable ? ' side-recs__swatch--unavailable' : '') + '"'
        + ' data-variant-id="' + v.id + '"'
        + ' aria-label="Add size ' + esc(label) + (unavailable ? ' — sold out' : '') + '"'
        + (unavailable ? ' disabled' : '')
        + '>'
        + esc(label)
        + '</button>';
    }).join('');
    return '<div class="side-recs__picker" hidden>' + swatches + '</div>';
  }

  // ── Floating picker state ─────────────────────────────────────────────────
  var activeExpandBtn = null;
  var outsideClickTimer = null;

  function showFloat(expandBtn) {
    hideFloat(); // close any previously open float first

    var card = expandBtn.closest('.side-recs__card');
    var srcPicker = card && card.querySelector('.side-recs__picker');
    if (!srcPicker) return;

    var float = document.getElementById('side-recs-float');
    if (!float) return;

    // Clone swatch HTML from the (always-hidden) in-card picker
    float.innerHTML = srcPicker.innerHTML;
    float.hidden = false;

    // Position fixed just below the expand button
    var rect = expandBtn.getBoundingClientRect();
    float.style.left = rect.left + 'px';
    float.style.top = (rect.bottom + 2) + 'px';
    float.style.width = rect.width + 'px';

    expandBtn.setAttribute('aria-expanded', 'true');
    activeExpandBtn = expandBtn;

    // Bind clicks on the newly created swatches
    float.querySelectorAll('.side-recs__swatch').forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (sw.disabled) return;
        var variantId = parseInt(sw.getAttribute('data-variant-id'), 10);
        hideFloat();
        addVariant(variantId, expandBtn);
      });
    });

    // Dismiss on outside click (deferred so this click doesn't immediately close it)
    outsideClickTimer = setTimeout(function () {
      outsideClickTimer = null;
      document.addEventListener('click', onOutsideClick, true);
    }, 0);

    // Dismiss on drawer scroll
    var scrollEl = document.querySelector('.side > content .cart .items');
    if (scrollEl) {
      scrollEl.addEventListener('scroll', hideFloat, { once: true, passive: true });
    }
  }

  function hideFloat() {
    if (outsideClickTimer !== null) {
      clearTimeout(outsideClickTimer);
      outsideClickTimer = null;
    }
    var float = document.getElementById('side-recs-float');
    if (float) {
      float.hidden = true;
      float.innerHTML = '';
    }
    if (activeExpandBtn) {
      activeExpandBtn.setAttribute('aria-expanded', 'false');
      activeExpandBtn = null;
    }
    document.removeEventListener('click', onOutsideClick, true);
  }

  function onOutsideClick(e) {
    var float = document.getElementById('side-recs-float');
    // Let clicks inside the float and on expand buttons pass through
    if (float && float.contains(e.target)) return;
    if (e.target.classList.contains('side-recs__card-add--expand')) return;
    hideFloat();
  }

  // ── Events ────────────────────────────────────────────────────────────────
  function bindEvents(track) {
    track.querySelectorAll('.side-recs__card-add').forEach(function (btn) {
      btn.addEventListener('click', onAddClick);
    });
    // Note: swatch clicks are bound dynamically inside showFloat
  }

  function onAddClick(e) {
    e.preventDefault();
    e.stopPropagation();
    var btn = e.currentTarget;
    if (btn.classList.contains('side-recs__card-add--expand')) {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        hideFloat();
      } else {
        showFloat(btn);
      }
      return;
    }
    addVariant(parseInt(btn.getAttribute('data-variant-id'), 10), btn);
  }

  function addVariant(variantId, triggerEl) {
    if (triggerEl) triggerEl.setAttribute('data-loading', '');
    CartJS.addItem(variantId, 1, {}, {
      success: function () {
        if (triggerEl) {
          triggerEl.removeAttribute('data-loading');
          var prev = triggerEl.textContent;
          triggerEl.textContent = 'Added';
          triggerEl.setAttribute('data-added', '');
          setTimeout(function () {
            triggerEl.textContent = prev;
            triggerEl.removeAttribute('data-added');
          }, 2000);
        }
        document.dispatchEvent(new CustomEvent('cart:upsell:added', {
          bubbles: true,
          detail: { variantId: variantId, source: 'side-cart-recommendations' }
        }));
      },
      error: function () {
        if (triggerEl) triggerEl.removeAttribute('data-loading');
      }
    });
  }

  // ── Utilities ─────────────────────────────────────────────────────────────
  function sizedUrl(src, w, h) {
    if (typeof Shopify !== 'undefined' && Shopify.Image && Shopify.Image.getSizedImageUrl) {
      return Shopify.Image.getSizedImageUrl(src, w + 'x' + h + '_crop_top');
    }
    return src.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x' + h + '_crop_top$1$2');
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney &&
        typeof CartJS !== 'undefined' && CartJS.settings && CartJS.settings.moneyFormat) {
      return Shopify.formatMoney(cents, CartJS.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  return { init: init, refresh: refresh };
})();
